import Axios from "axios";
import { CheckerService_URL } from "../../../../redux/Url";
import CryptoJS from "crypto-js";

export const fetchToDetailsForChecker = async ({
  access_token,
  boxNumber,
  ...props
}) => {
  const config = { headers: { Authorization: `Bearer ${access_token}` } };
  let url = new URL(`${CheckerService_URL}/fetchToDetailsForChecker`);
  let keys = Object.keys(props);
  keys.forEach((item) => {
    if (props[item]) {
      url.searchParams.append(item, props[item]);
    }
  });
  return await Axios.get(url, config);
};
export const verifyCheckerMedicineData = async ({ access_token, data }) => {
  const config = { headers: { Authorization: `Bearer ${access_token}` } };
  let url = new URL(`${CheckerService_URL}/verifyCheckerMedicineData`);
  return await Axios.post(url, data, config);
};
export const holdToApiCall = async ({
  access_token,
  toNumber,
  checkedBoxes,
}) => {
  const config = { headers: { Authorization: `Bearer ${access_token}` } };
  let url = new URL(
    `${CheckerService_URL}/holdTO?toNumber=${toNumber}&reasonId=${6}`
  );
  return await Axios.post(url, checkedBoxes, config);
};
export const isAllBoxesScanned = async ({ access_token, toNumber }) => {
  const config = { headers: { Authorization: `Bearer ${access_token}` } };
  let url = new URL(
    `${CheckerService_URL}/isAllBoxesScanned?toNumber=${toNumber}`
  );
  return await Axios.post(url, {}, config);
};
export const prinInvoiceCall = async ({ access_token, ...props }) => {
  const config = { headers: { Authorization: `Bearer ${access_token}` } };
  let url = new URL(`${CheckerService_URL}/generateTransferOrderInvoicePdf`);
  let keys = Object.keys(props);
  keys.forEach((item) => {
    if (props[item]) {
      url.searchParams.append(item, props[item]);
    }
  });
  return await Axios.post(url, [], config);
};
export const decodeString = (string) => {
  try {
    var decodedWordArray = CryptoJS.enc.Base64.parse(string);
    var decodedString = CryptoJS.enc.Utf8.stringify(decodedWordArray);
    return decodedString;
  } catch (error) {
    return "";
  }
};
const fileDownloader = (url) => {
  var element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("download", "Invoice download");
  element.setAttribute("target", "_blank");
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
export default fileDownloader;
